import { useCallback } from "react";
import type { GridToolbarProps } from "@mui/x-data-grid-premium";
import { useHasPrivilege } from "../../hooks/useHasPrivilege";
import { TAGGING_RESULT_PRIVILEGES } from "../../services/permissionsService";
import type { TaggingResultRow } from "./constants";
import AiHubTableToolbar from "./AiHubTableToolbar";
import { TAGGING_RESULT_EXPORT_COPY } from "./exportCopy";
import {
  downloadTaggingResultsExcel,
  type TaggingResultDisplayConcept,
} from "./taggingResultData";

type TaggingResultTableToolbarProps = GridToolbarProps & {
  selectedRows?: TaggingResultRow[];
  displayConcepts?: readonly TaggingResultDisplayConcept[];
  objectTypeLabel?: string;
  objectSubTypeLabel?: string;
  objectIdSearch?: string;
  onObjectIdSearchChange?: (value: string) => void;
};

export default function TaggingResultTableToolbar({
  selectedRows = [],
  displayConcepts = [],
  objectTypeLabel = "",
  objectSubTypeLabel = "",
  objectIdSearch,
  onObjectIdSearchChange,
}: TaggingResultTableToolbarProps) {
  const canExportTaggingResult = useHasPrivilege(
    TAGGING_RESULT_PRIVILEGES.read,
  );

  const handleExport = useCallback(
    () =>
      downloadTaggingResultsExcel(selectedRows, displayConcepts, {
        objectTypeLabel,
        objectSubTypeLabel,
      }),
    [displayConcepts, objectSubTypeLabel, objectTypeLabel, selectedRows],
  );

  return (
    <AiHubTableToolbar
      exportTooltip={TAGGING_RESULT_EXPORT_COPY.selectedTooltip}
      emptyExportTooltip={TAGGING_RESULT_EXPORT_COPY.emptyTooltip}
      hasExportSelection={selectedRows.length > 0}
      exportFailureMessage={TAGGING_RESULT_EXPORT_COPY.failureMessage}
      onExport={handleExport}
      showExport={canExportTaggingResult}
      objectIdSearch={objectIdSearch}
      onObjectIdSearchChange={onObjectIdSearchChange}
    />
  );
}
